import EductionalDetails from "./eductionalDetails";
export default EductionalDetails;